import PosthogService from '~/services/posthog/PosthogService';
import { EndOfDayAdjustmentType } from './types';

export interface IEndOfDayEditTimeClickedPayload {
  shiftId: string;
  adjustmentType: EndOfDayAdjustmentType;
}

/**
 * Fires when an office clicks an edit button on the end-of-day adjustment page.
 * Event: dental_portal:end_of_day:edit_time_clicked
 */
export function fireEndOfDayEditTimeClicked(payload: IEndOfDayEditTimeClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:end_of_day:edit_time_clicked', {
    shift_id: payload.shiftId,
    adjustment_type: payload.adjustmentType,
  });
}
